import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Course, Trail } from '../interfaces';
import { mediaClient } from '@/data/@clients';

export const useOngoingCoursesIndex = () => {
  const { data, isLoading, error } = useQuery<Trail[]>({
    queryKey: ['ongoing-courses'],
    queryFn: () => mediaClient.get('/courses/ongoing_courses'),
  });

  return { ongoingCourses: data, isLoading, error };
};

export const useCompletedCoursesIndex = () => {
  const { data, isLoading, error } = useQuery<Trail[]>({
    queryKey: ['completed-courses'],
    queryFn: () => mediaClient.get('/courses/completed_courses'),
  });
  return { completedCourses: data, isLoading, error };
};

export const useShowCourse = (courseId: string) =>
  useQuery<Course>({
    queryKey: ['course', courseId],
    queryFn: () => mediaClient.get(`/courses/${courseId}`),
  });

export const useUpdateCourseProgress = (courseId: string) => {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, { progress: number }>({
    mutationFn: async ({ progress }) =>
      await mediaClient.patch(`/courses/${courseId}/update_progress`, {
        progress,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['course', courseId],
      });
    },
  });
};
